import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import NumberIcons from 'assets/Icons/Numbers';
import Image from 'next/image';
import Link from 'next/link';

interface BookCardProps {
  book: {
    title: string;
    coverImage: string;
    slug: string;
    id: string;
    rank: number;
    isExternalLink?: boolean;
    externalLink?: string;
  };
}

const BookRankCard: React.FC<BookCardProps> = ({ book }) => {
  const RankIcon = NumberIcons[book.rank];
  const screens = useBreakpoint();
  const imageWidth = screens.md ? 113 : 72;
  const imageHeight = screens.md ? 160 : 102;

  const isExternal = !book.isExternalLink && !!book.externalLink;
  const linkHref = isExternal
    ? book.externalLink!
    : `/books/${book.slug}-${book.id}`;

  return (
    <Link
      href={linkHref}
      passHref
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
    >
      <div className='relative flex items-center justify-center cursor-pointer'>
        {RankIcon && (
          <Image
            src={RankIcon}
            alt={`Rank ${book.rank}`}
            width={!screens.md ? 63 : 124}
            height={!screens.md ? 88 : 160}
            className='absolute z-0 bottom-0 left-0 pointer-events-none select-none'
          />
        )}

        <div
          style={{ width: imageWidth, height: imageHeight }}
          className='relative ml-[40px] md:ml-20 flex-shrink-0'
        >
          <Image
            src={book.coverImage || '/placeholder.svg'}
            alt={book.title}
            fill
            className='rounded shadow-lg hover:scale-105 transition-transform duration-300 object-cover'
          />
        </div>
      </div>
    </Link>
  );
};

export default BookRankCard;
